import React, { memo } from 'react';

import { Stack } from '@mui/material';
import { TableCDS } from '@sharedCR/coreDesignSystem/Table';
import PropTypes from 'prop-types';

import TableTabToolbar from '../TableTabToolbar';

import { tableClassName as defaultTableClassName, wrapperStyles } from './SystemTable.styles';

const SystemTable = ({
  // TableToolbar props
  activeTab = '',
  setActiveTab,
  isShowTabToolbar = false,
  isLoading = false,
  onSearch,
  tabsDefs,
  onTabChange,
  // TableCDS props
  config,
  data,
  order,
  onRequestSort,
  onRowClick,
  isCustomDataDefinition = false,
  skeletonRows = 3,
  className,
  testId = 'system-table',
  isSearchOnChange = true,
  validQueryLength = 1,
  customSearchControls,
  // Pagination props
  fetchTableData,
  paginationProps,
  ...restTableProps
}) => {
  return (
    <Stack data-testid={testId} sx={wrapperStyles}>
      {isShowTabToolbar && (
        <TableTabToolbar.CDS
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsDefs={tabsDefs}
          onTabChange={onTabChange}
        />
      )}
      <TableCDS
        isStickyHeader
        withNoAvailableMessage
        {...restTableProps}
        className={className || defaultTableClassName}
        config={config}
        customSearchControls={customSearchControls}
        data={data}
        fetchTableData={fetchTableData}
        isCustomDataDefinition={isCustomDataDefinition}
        isLoading={isLoading}
        isSearchOnChange={isSearchOnChange}
        order={order}
        paginationProps={paginationProps}
        skeletonRows={skeletonRows}
        validQueryLength={validQueryLength}
        withSearch={!!onSearch}
        onRequestSort={onRequestSort}
        onRowClick={onRowClick}
        onSearch={onSearch}
      />
    </Stack>
  );
};

SystemTable.propTypes = {
  // TableCDS props
  config: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  // TableToolbar props
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setActiveTab: PropTypes.func,
  isShowTabToolbar: PropTypes.bool,
  isLoading: PropTypes.bool,
  tabsDefs: PropTypes.array,
  order: PropTypes.shape({
    id: PropTypes.string,
    direction: PropTypes.oneOf(['asc', 'desc']),
  }),
  isCustomDataDefinition: PropTypes.bool,
  skeletonRows: PropTypes.number,
  className: PropTypes.string,
  testId: PropTypes.string,
  isSearchOnChange: PropTypes.bool,
  validQueryLength: PropTypes.number,
  fetchTableData: PropTypes.func,
  customSearchControls: PropTypes.node,
  paginationProps: PropTypes.shape({
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    rowsPerPageOptions: PropTypes.array,
    onRowsPerPageChange: PropTypes.func,
  }),
  columnFilters: PropTypes.object,
  onColumnFiltersChange: PropTypes.func,
  onRequestSort: PropTypes.func,
  onRowClick: PropTypes.func,
  onSearch: PropTypes.func,
  onTabChange: PropTypes.func,
};

export default memo(SystemTable);
